// Ported from the portal's Customer/Tabs/Settings — vestigial surface: the tab
// trigger is commented out, but ?cardTab=settings still reaches the content.
import { Box, Radio, Card } from 'vopay';
import { useTranslation } from 'react-i18next';

type SettingsTabProps = {
  lang: string;
  clientAccountsEnabled: boolean;
  receiveOnly?: boolean;
};

export default function SettingsTab({ lang, clientAccountsEnabled, receiveOnly }: SettingsTabProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.Customers.SettingsTab' });

  return (
    <Box flx="col" gapSize="24px">
      <Card title={t('defaultLanguageTitle', { defaultValue: 'Default Language' })}>
        <Box jc="sb">
          <Box>
            {t('defaultLanguageDescription', {
              defaultValue: 'The primary language used to communicate with this client account.',
            })}
          </Box>

          <Box jc="fe" pe="smd">
            <Radio
              name="client-account-language"
              variant="inline"
              value={lang || 'en'}
              options={{
                en: t('Languages.en', { defaultValue: 'English' }),
                fr: t('Languages.fr', { defaultValue: 'French' }),
              }}
              readOnly
              onChange={() => {}}
            />
          </Box>
        </Box>
      </Card>

      {clientAccountsEnabled && (
        <Card title={t('transactionPermissionsTitle', { defaultValue: 'Transaction Permissions' })}>
          <Box jc="sb" ai="fe">
            <Box lineHeight="150%" maxwidth="50%">
              {t('transactionPermissionsDescription', {
                defaultValue:
                  'Send & Receive funds client accounts allow outbound and inbound transactions. Receive-Only Client Accounts are limited to inbound transactions.',
              })}
            </Box>

            <Box jc="fe" pe="smd">
              <Radio
                name="client-account-type"
                variant="inline"
                value={receiveOnly ? 'receiveOnly' : 'sendReceive'}
                options={{
                  sendReceive: t('Permissions.sendReceive', { defaultValue: 'Send & Receive Funds' }),
                  receiveOnly: t('Permissions.receiveOnly', { defaultValue: 'Receive-Only' }),
                }}
                noOrdering
                readOnly
                onChange={() => {}}
              />
            </Box>
          </Box>
        </Card>
      )}
    </Box>
  );
}
